import React, { useEffect, useState } from "react";
import "./Header.css";
import logo from "../../assets/images/logo-transparent.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sample1 from "../../assets/images/sample1.jpg";
import sample2 from "../../assets/images/sample2.jpg";
import { Link } from "react-scroll";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Header background on scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu when resizing to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <header className={`fixed-nav ${scrolled ? "scrolled" : ""} ${menuOpen ? "menu-open" : ""}`}>
        <div className="header-top">
          {/* Logo + Name */}
          <div className="header-logo">
            <img src={logo} alt="Genesis Sequence Solutions Logo" />
            <h1>Genesis Sequence Solutions</h1>
          </div>

          {/* Nav + Hamburger */}
          <div className="nav-and-toggle">
            {/* Navigation Menu - SEPARATE from hamburger button */}
            <nav className={menuOpen ? "active" : ""} role="navigation" aria-label="Main">
              <ul className="nav-links">
                <li>
                  <Link to="services" smooth duration={800} onClick={() => setMenuOpen(false)}>
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="about" smooth duration={800} onClick={() => setMenuOpen(false)}>
                    About
                  </Link>
                </li>
                <li>
                  <Link to="portfolio" smooth duration={800} onClick={() => setMenuOpen(false)}>
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link to="contact" smooth duration={800} onClick={() => setMenuOpen(false)}>
                    Contact
                  </Link>
                </li>
              </ul>
            </nav>

            {/* Hamburger button - ONLY contains the three span bars */}
            <button
              className={`header-toggle ${menuOpen ? "active" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
              type="button"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Carousel */}
      <div className="header-carousel">
        <Slider {...settings}>
          <div className="carousel-slide">
            <img src={sample1} alt="Hero Background 1" />
            <div className="overlay">
              <div className="hero-content">
                <h2>Custom Solutions, Tailored for Your Business</h2>
                <p>From AI-powered tools to plugin development—we transform your vision into code.</p>
                <Link to="contact" smooth duration={800}>
                  <button className="cta-button">Let's Work Together</button>
                </Link>
              </div>
            </div>
          </div>

          <div className="carousel-slide">
            <img src={sample2} alt="Hero Background 2" />
            <div className="overlay">
              <div className="hero-content">
                <h2>Custom Solutions, Tailored for Your Business</h2>
                <p>From AI-powered tools to plugin development—we transform your vision into code.</p>
                <Link to="contact" smooth duration={800}>
                  <button className="cta-button">Let's Work Together</button>
                </Link>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </>
  );
};

export default Header;